import type { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useDocumentsFeatureOptional } from "web_myplann/Api/Rights/RightsProvider";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";

interface PaperworkRightGuardProps {
	children: ReactNode;
}

export const PaperworkRightGuard: FC<PaperworkRightGuardProps> = ({
	children,
}) => {
	const hasDocumentsFeature = useDocumentsFeatureOptional();

	if (!hasDocumentsFeature) {
		return (
			<Navigate to={AppRouting.MyPlann.Profile.Paperwork.path()} replace />
		);
	}

	return <>{children}</>;
};
